module.exports = __webpack_public_path__ + "static/img/news1ab.c16422ce.jpg";